import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// VO == on-screen caption. Every claim is grounded in the EAKC-MVP 2026-06-15 session.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.4, holdSec: 5.5, caption: "I asked my own knowledge assistant one question: how is EAKC's pipeline built?" },
  { scene: "hook", fromSec: 6, holdSec: 5, caption: "One question. And it found four different ways to get the answer wrong." },
  { scene: "hook", fromSec: 11.2, holdSec: 4.5, caption: "Wrong project. Wrong length. Wrong room. And one it knew was wrong — but shipped anyway." },
];

export const LEAK: ScriptLine[] = [
  { scene: "leak", fromSec: 0.4, holdSec: 6, caption: "First: it answered about a totally different project in the same account — a trading system." },
  { scene: "leak", fromSec: 6.5, holdSec: 6, caption: "Every citation said EAKC. But the words described brokers, orders, portfolios." },
  { scene: "leak", fromSec: 13, holdSec: 6.5, caption: "The fix: lock every answer to only the project you asked about — and drop any stray chunk before it's written." },
];

export const STOP: ScriptLine[] = [
  { scene: "stop", fromSec: 0.4, holdSec: 5.5, caption: "Then the answers started dying after two words. Response generated: two words. 'The E.'" },
  { scene: "stop", fromSec: 6, holdSec: 6, caption: "A speed tweak routed to a fast server that ignored a setting. The model thought silently and printed almost nothing." },
  { scene: "stop", fromSec: 12.2, holdSec: 5.5, caption: "Reverted the tweak. Full answers stream again. Speed can come back — the safe way." },
];

export const ROOM: ScriptLine[] = [
  { scene: "room", fromSec: 0.4, holdSec: 6.5, caption: "Ask 'how is the pipeline built?' and it listed admin screens as the major subsystems." },
  { scene: "room", fromSec: 7.2, holdSec: 6, caption: "It picked the most-connected files, not the most relevant ones. Admin pages connect to everything." },
  { scene: "room", fromSec: 13.5, holdSec: 7.5, caption: "Now it ranks files by how related they are to YOUR question. The real pipeline files win." },
];

export const CRAG: ScriptLine[] = [
  { scene: "crag", fromSec: 0.4, holdSec: 6, caption: "EAKC has a built-in fact-checker. It correctly graded the results: INCORRECT." },
  { scene: "crag", fromSec: 6.5, holdSec: 5, caption: "Then it skipped the retry — and wrote the answer anyway." },
  { scene: "crag", fromSec: 11.8, holdSec: 6, caption: "Now a 'wrong' verdict triggers a quick second search. A cheap retry, not the slow fifty-second one." },
];

export const MEASURE: ScriptLine[] = [
  { scene: "measure", fromSec: 0.4, holdSec: 5.5, caption: "The deepest miss: the real pipeline file never even got found." },
  { scene: "measure", fromSec: 6, holdSec: 5.5, caption: "So I turned it into an eval case — built to fail today, so we can track when it's fixed." },
  { scene: "measure", fromSec: 11.8, holdSec: 4.5, caption: "Measure the gap. Don't guess at it." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 4.5, caption: "Four ways to be wrong. Four fixes. One rule." },
  { scene: "outro", fromSec: 5, holdSec: 4.5, caption: "Lock the scope. Measure the rest." },
  { scene: "outro", fromSec: 9.8, holdSec: 6, caption: "EAKC — a knowledge companion getting more honest, one bug at a time." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
